/**
 * ESG dashboard API — see ESG_DASHBOARD_API.md (monthly / overview / by-branch under `/dashboard/esg/...`).
 */
import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { OrganizationType } from '../types/organization.type';
import type {
  EsgDashboardByBranchResponse,
  EsgDashboardMonthlyResponse,
  EsgDashboardOverviewResponse,
  EsgDashboardPersona,
  EsgMonthQuery,
} from '../types/esg-dashboard.type';

export function getEsgPersonaSegment(orgType: OrganizationType): EsgDashboardPersona {
  switch (orgType) {
    case OrganizationType.WASTE_OUTLET:
      return 'waste-outlet';
    case OrganizationType.RECYCLER:
      return 'recycler';
    case OrganizationType.TRUCK:
      return 'trucker';
  }
}

function esgBasePath(persona: EsgDashboardPersona, organizationId: string): string {
  return `/dashboard/esg/${persona}/${organizationId}`;
}

export function getEsgDashboardMonthly(
  persona: EsgDashboardPersona,
  organizationId: string,
  monthQuery: EsgMonthQuery
): Promise<EsgDashboardMonthlyResponse> {
  return makeRequest({
    url: `${esgBasePath(persona, organizationId)}/monthly`,
    method: HttpMethods.GET,
    params: monthQuery,
  });
}

export function getEsgDashboardOverview(
  persona: EsgDashboardPersona,
  organizationId: string
): Promise<EsgDashboardOverviewResponse> {
  return makeRequest({
    url: `${esgBasePath(persona, organizationId)}/overview`,
    method: HttpMethods.GET,
  });
}

export function getEsgDashboardByBranch(
  persona: EsgDashboardPersona,
  organizationId: string,
  monthQuery: EsgMonthQuery
): Promise<EsgDashboardByBranchResponse> {
  return makeRequest({
    url: `${esgBasePath(persona, organizationId)}/by-branch`,
    method: HttpMethods.GET,
    params: monthQuery,
  });
}
